module.exports = "/assets/about/fourth/pawel.png?Ytjt+cK";